import { memo } from 'react';
import { TermsTemplate } from 'components/templates/TermsTemplate';

type Props = {};

export const TermsPage = memo((_props: Props) => {
	return <TermsTemplate />;
});
